(function($) {
  'use strict';

  if (!$('html').hasClass('properties-listing')) {

    var filter = {
      dom: function() {
        this.$filterContent       = $('#filterContent');
        this.$filterItems         = $('[data-filter-item]');
        this.$pageFilterInfo      = $('#pageFilterInfo');
        this.$pageFilterInfoCount = $('#pageFilterInfoCount');
        this.$noresults           = $('[data-js-hook="pageFilterNoResults"]');
        this.$resultCount         = $('.js-result-count-text');
        this.$selectFilter        = $('[data-js-hook="selectFilter"]');

        this.$filters = {
          form     : $('#pageFilters'),
          all      : $('#pageFilters').find(':input'),
          input    : $('[data-filter="input"]'),
          select   : $('[data-filter="select"]'),
          checkbox : $('[data-filter="checkbox"]'),
          reset    : $('[data-filter="reset"]'),
          submit   : $('[data-filter="submit"]'),
          dummy    : $('[data-filter-dummy]')
        };
      },

      definitions: function() {
        this.matchedItems = [];
        this.notMatchedItems = [];
        this.itemIds = [];
      },

      settings: {
        filterName: ''
      },

      validateResults: function(search_data, element_data) {
        // loop through fields [AND]
        for (var key in search_data) {
          if (key) {
            // remove if no data for that field
            if (element_data[key] == null) {
              return false;
            }

            var data = element_data[key].toLowerCase();

            if (typeof search_data[key] === 'string') {
              // data = data.join();
              if (data.indexOf(search_data[key].toLowerCase()) === -1) {
                return false;
              }
            }

            // if object then loop
            if (typeof search_data[key] === 'object') {
              // loop through field values (checkboxes) [OR]
              var match = false;
              $.each(search_data[key], function(index, value) {
                if (data.indexOf(value.toLowerCase()) !== -1) {
                  match = true;
                }
              });
              if (!match) {
                return false;
              }
            }
          }
        }

        return true;
      },

      setFilters: function() {
        var self = this;

        var aPath = window.location.pathname.replace(/\/$/, '').split('/');
        this.settings.filterName = aPath[aPath.length - 1];

        if (localStorage.key(filter.settings.filterName + '-filters')) {
          var localStorageData = localStorage.getItem(filter.settings.filterName + '-filters');
          var savedData = JSON.parse(localStorageData);

          if (localStorageData && localStorageData.length > 2) {
            var i;
            for (i = 0; i <= self.$filters.all.length; i++) {
              var element = self.$filters.all[i];
              if (element && element.name) {
                var data = savedData[element.name];
                if ( typeof data != 'undefined' ) {
                  if (typeof data === 'object' && (element.type == 'checkbox' || element.type == 'radio')) {
                    $.each(data, function(index, value) {
                      if (element.value == value) {
                        element.checked = true;
                      }
                    });
                  }
                  else {
                    element.value = data;
                  }
                }
              }
            }

            if (self.$filters.input.length) {
              self.$filters.input.trigger('input');
            }
            else {
              self.$filters.form.submit();
            }
          }
        }
      },

      showInputClear: function(element) {
        if (typeof element != 'undefined' && element.length) {
          if (element.val().length) {
            element.parent().addClass('has-value');
          }
          else {
            element.parent().removeClass('has-value');
          }
        }
        else {
          $('[type="text"]', this.$filters.form).each(function() {
            filter.showInputClear($(this));
          });
        }
      },

      filter: function() {
        var self = this;

        // DUMMY INPUT
        this.$filters.dummy.on('keyup touchend', function() {
          var id = $(this).data('filter-dummy');
          var value = this.value;
          var $input = self.$filters.input.filter('#' + id);
          $input.val(value).trigger('input');

          filter.showInputClear($(this));
        });

        // INPUT/TEXT
        this.$filters.input.on('input keyup touchend', function() {
          var form = $(this).closest('form');
          var value = this.value;
          var id = $(this).attr('id');
          var $dummy = self.$filters.dummy.filter('[data-filter-dummy="' + id + '"]');
          $dummy.val(value).trigger('input');

          filter.showInputClear($(this));
          filter.showInputClear($dummy);

          // submit form
          form.submit();
        });

        // SELECT
        this.$filters.select.on('change', function() {
          var form = $(this).closest('form');
          form.submit();
        });

        // CHECKBOX
        this.$filters.checkbox.on('change', function() {
          var form = $(this).closest('form');
          form.submit();
        });

        // CHECKBOX
        this.$filters.reset.on('click', function() {
          var $form;
          if ($(this).attr('data-parent-form')) {
            $form = $($(this).data('parent-form'));
          }
          else {
            $form = $(this).closest('form');
          }
          $form.trigger('reset');
          filter.$filters.input.trigger('input');
        });

        // CHECKBOX
        this.$filters.submit.on('click', function() {
          var form = $(this).closest('form');
          form.submit();
          $(this).closest('.slideout').find('[data-slideout="close"]').first().trigger('click');
        });

        // FORM SUBMIT
        this.$filters.form.on('submit', function(event) {
          event.preventDefault();

          var aFormData = {};
          var aLocalStorageData = {};
          self.matchedItems = [];

          var formData = $(this).serializeArray();
          formData.forEach(function(data) {
            if (data.name.length > 0 && data.value) {
              if (data.name.match(/\[\]$/)) {
                var name = data.name.replace(/\[\]$/, '');
                if (!aFormData[name]) {
                  aFormData[name] = [];
                  aLocalStorageData[data.name] = [];
                }
                aLocalStorageData[data.name].push(data.value);
                aFormData[name].push(data.value);
              }
              else {
                aLocalStorageData[data.name] = data.value;
                aFormData[data.name] = data.value;
              }
            }
          });

          // loop through items and start filtering
          self.$filterItems.each(function(index, element) {
            var id = parseInt(element.dataset.filterItem, 10);

            if (Object.keys(aFormData).length) {
              if (element.dataset.filterItem && element.dataset.filterData) {
                // check to make sure that there is form data
                var filterData = JSON.parse(element.dataset.filterData);
                if (self.validateResults(aFormData, filterData)) {
                  self.matchedItems.push(id);
                }
              }
            }
            else {
              self.matchedItems.push(id);
            }
          });

          // Hide all items first
          self.$filterItems.hide();

          // if there are matched items
          if (self.matchedItems.length) {
            self.$noresults.parent().removeClass('no-results');
            self.$noresults.hide();
            self.$filterItems.hide();

            self.matchedItems.forEach(function(id) {
              self.$filterItems.filter('[data-filter-item="' + id + '"]').show();
            });

            if (self.matchedItems.length === self.$filterItems.length) {
              self.$pageFilterInfoCount.text('');
              self.$pageFilterInfo.hide();
              self.$resultCount.text('View All Results');
            }
            else {
              self.$pageFilterInfoCount.text(self.matchedItems.length + ' Result' + (self.matchedItems.length > 1 ? 's' : ''));
              self.$pageFilterInfo.show();
              self.$resultCount.text('View ' + self.matchedItems.length + ' Result' + (self.matchedItems.length > 1 ? 's' : ''));
            }
          }
          else {
            self.$pageFilterInfoCount.text('');
            self.$pageFilterInfo.hide();
            self.$noresults.parent().addClass('no-results');
            self.$noresults.show();
            self.$resultCount.text('No results found');
          }

          if (typeof(Storage) !== 'undefined') {
            localStorage.setItem(filter.settings.filterName + '-filters', JSON.stringify(aLocalStorageData));
          }
        });
      },

      selectFilter: function() {
        this.$selectFilter.on('change', function(event) {
          event.preventDefault();
          var value = $(this).val();
          var id = $(this).attr('id');
          var $targets = $('[data-' + id + ']');

          if (value) {
            $targets.hide().filter('[data-' + id + '="' + value + '"]').show();
          }
          else {
            $targets.show();
          }
        });
      },

      ready: function() {
        this.dom();
        this.definitions();
        this.filter();
        this.setFilters();
        this.selectFilter();
      }
    };

    $(function() { filter.ready(); });

  }

})(jQuery);
